import AT from '../actions/ActionTypes';
import { logout as logoutApi } from '../api/auth/auth.api';
import { joinExistingAccount } from '../api/SignupService';
import { clearNudges } from '../components/ask-moo/dwell/nudgeStore';
import { LOCAL_STORAGE_KEYS } from '../local-storage.consts';

function clearClientState() {
  const uiSettings = localStorage.getItem('cowbell');
  const cookieConsent = localStorage.getItem(
    LOCAL_STORAGE_KEYS.COOKIES_ENABLED
  );

  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem('cowbell', uiSettings);
  localStorage.setItem(LOCAL_STORAGE_KEYS.COOKIES_ENABLED, cookieConsent);

  // OMNI-480: the proactive-nudge store is in-memory (survives an SPA logout
  // with no full reload), so drop it here too — otherwise the next user signing
  // in on the same tab could see the previous session's nudges / conversation ids.
  clearNudges();
}

export const logout = () => (dispatch: any) => {
  // eslint-disable-next-line no-console
  logoutApi().catch(console.error);
  clearClientState();
  dispatch({ type: AT.USER_LOGOUT });
};

/* JOIN Existing User Account */
export const submitJoinExistingAccount =
  (credentials: any, token: any) => () => {
    return joinExistingAccount(credentials, token);
  };
